import { axiosInstance } from "api/axios";
import { IComplianceInfo, IResponse, IUpdateFinancial, MetaDataCoporate } from "./types";

export const getComplianceInfo = async (request: any): Promise<IComplianceInfo> => {
	const { data } = await axiosInstance.get(`/corporate-investors/compliance`, request);
	return data;
};

export const getMetadataCoporate = async (request: any): Promise<MetaDataCoporate> => {
	const { data } = await axiosInstance.get(`/metadata/corporate-investors`, request);
	return data;
};

export const submitPepDeclaration = async (request: any): Promise<IResponse> => {
	return await axiosInstance.post(`/corporate-investors/pep-declaration`, request);
};

export const updateFinanceDeclaration = async (request: IUpdateFinancial): Promise<IResponse> => {
	return await axiosInstance.post(`/corporate-investors/financial`, request);
};

export const deletePepDeclaration = async (request: any): Promise<IResponse> => {
	return await axiosInstance.delete(`/corporate-investors/pep-declaration`, { data: request });
};
